import superAdminRoutes from './super'
import userRoutes from './user'


const routes = [
	// { path: '/', exact: true, name: 'Home' },

	...superAdminRoutes,

	...userRoutes,
]

export default routes